module.exports = __webpack_public_path__ + "img/logo_inilahcom.5a532e02.png";